export default __webpack_public_path__ + "static/Q6_3_LargeDog-090bf68f354c4b0a0feac5a57ad4d7a0.svg";